<template>
  <div class="procedures-filter filters-container">
    <select-filter
      type="procedures"
      field="type"
      label="Тип"
      request="objectInfo/procedure_types"
      :parse-value="({ name }) => name"
    />
    <select-filter
      type="procedures"
      field="status"
      label="Статус"
      request="objectInfo/procedure_statuses"
      :parse-value="({ name }) => name"
    />
    <sorting-control
      style="margin-left: 32px;"
      type="procedures"
      :values="sortingFields"
    />
  </div>
</template>

<script>
import SelectFilter from './helpers/select-filter'
import SortingControl from './helpers/sorting-control'

const sortingFields = [
  { field: 'date', name: 'Дата' }
]

export default {
  components: {
    SelectFilter,
    SortingControl
  },
  data () {
    return {
      sortingFields
    }
  }
}
</script>

<style>

</style>
